export default "__VITE_ASSET__CLIuPs1u__"